import apiClient from './axios';
import qs from 'qs'; 

export async function fetchAdmins({ offset = 0, limit = 50 } = {}) {
  const res = await apiClient.get('/v3/cs/admin-user', {
    params: { 
      offset: offset, 
      limit: limit,
    },
    paramsSerializer: (p) => {
      return qs.stringify(p, {arrayFormat: 'repeat'});
    },
  });

  // console.log(`fetchAdmins: ${JSON.stringify(res, null, 2)}`);

  return res;
}

export async function createAdmin({ username, email, password, role }) {
  const res = await apiClient.post('/v3/cs/admin-user', {
    username,
    email,
    password,
    role,
  });

  return res.data.user;
}

export async function deleteAdmin(uuid) {
  const res = await apiClient.delete('/v3/cs/admin-user', {
    data: { uuid },
  });
  return res.data;
}
